// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c37cbc26","239":"24e6c1b3","453":"20acdddb","455":"2a0b4f5b"}[chunkId] + ".chunk.js";
};